import React, { useState, useEffect } from 'react'
import { Button, Typography } from '@mui/material';
import { Modal } from 'react-bootstrap'
import UpdateForm from './UpdateForm'

export default function AccountRateCodeSetup() {

  const [lgShow, setLgShow] = useState(false);
  const [accessType, setAccessType] = useState('')

  //API call
  useEffect(() => {

    const loggedInUser = sessionStorage.getItem("user_token");
    const foundUser = JSON.parse(loggedInUser);

    if (foundUser.role === 'SuperAdmin') {

      setAccessType('Edit');

    }
    else {

      setAccessType(foundUser.access['AccountRateCode_Access Specifier']);
    }

  }, []);

  return (
    <>


      <div className="row my-3 ">
        <div className="col-md-6">
          <Typography className="mx-3" variant='h4' sx={{ pb: 3 }}>
            Account Rate Codes {accessType === 'View' && "/ View Only Mode"}
          </Typography>
        </div>
        <div className="col-md-6 d-flex justify-content-end"   >

          <button type="button" className="btn btn-danger" onClick={() => setLgShow(true)} style={{ height: "40px" }}  >Help</button>
          <Modal
            size="lg"
            show={lgShow}
            onHide={() => setLgShow(false)}
            aria-labelledby="example-modal-sizes-title-lg"

          >
            <Modal.Header closeButton style={{ color: '#FFFFFF', backgroundColor: '#C62828' }}>
              <Modal.Title id="example-modal-sizes-title-lg" >
                Instructions to Add/Edit Account Rate Code
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <h5>Add New:
              </h5>
              <ol>
                <li>Select Account Name from dropdown &gt; Account ID and Account Type will genrate automatically.
                </li>
                <li>Select the required Rate Groups from the OTA's.
                </li>
                <li>Click on Submit button.
                </li>
              </ol>

              <h5>Existing Records:
              </h5>
              <ol>
                <li>Select the account name.
                </li>
                <li>The existing mapping will be shown. Make the required changes.</li>
              </ol>


            </Modal.Body>
          </Modal>

        </div>
      </div>


      {/* <div className="col-4 d-flex justify-content-end px-5">
        
          
         
        </div> */}



      {accessType === 'View' ? <UpdateForm accessType={accessType} /> : <UpdateForm />}


    </>
  );
}
